import { j as a } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as r } from "react";
import { I as i } from "../../../../IconBase-CxZyIWw2.js";
const n = r((o, e) => /* @__PURE__ */ a.jsx(
  i,
  {
    ref: e,
    ...o,
    image: (l) => /* @__PURE__ */ a.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...l,
        children: /* @__PURE__ */ a.jsx(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M8 2a1 1 0 0 0-1 1v1a1 1 0 0 1-1 1H5a3 3 0 0 0-3 3v1a1 1 0 0 0 1 1h26a1 1 0 0 0 1-1V8a3 3 0 0 0-3-3h-1a1 1 0 0 1-1-1V3a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v1a1 1 0 0 1-1 1H11a1 1 0 0 1-1-1V3a1 1 0 0 0-1-1zM2 14a2 2 0 0 1 2-2h24a2 2 0 0 1 2 2v13a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3zm19.542 3.429a1 1 0 0 1-.014 1.413l-6.331 6.217a1 1 0 0 1-1.408-.007l-3.082-3.081a1 1 0 0 1 0-1.415l.707-.707a1 1 0 0 1 1.414 0l1.682 1.682 4.917-4.83a1 1 0 0 1 1.415.014z",
            clipRule: "evenodd"
          }
        )
      }
    )
  }
));
n.displayName = "FormulaChangeIcon";
export {
  n as FormulaChangeIcon,
  n as default
};
//# sourceMappingURL=index.js.map
